// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"206":"page-about","271":"page-gekko-ai","309":"page-contact","532":"page-home-alt","632":"page-service","831":"page-error"}[chunkId] + "." + {"206":"432bf1be","271":"309071c6","309":"c43e9624","532":"a85633b3","632":"1039cbe0","831":"a4d90964"}[chunkId] + ".chunk.js";
};